<span class="pl-1">
    <ng-template #help>
        <div [innerHTML]="message"></div>
    </ng-template>
    <fa-icon [icon]="['fas', 'question-circle']" size='{{big ? "md" : "sm" }}' placement="right" [ngbTooltip]="help"></fa-icon>
</span>